// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"476":"component---src-pages-using-ssr-js","678":"component---src-pages-index-js","713":"component---src-templates-using-dsg-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"476":"db6c99074f3998f0fab3","678":"d24589381133234c16d2","713":"8623d323a6f20c561d7e","883":"2db42b819547a36a252a"}[chunkId] + ".js";
};